import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nn2hu33twq: FaireBrandEntity = {
  token: "b_nn2hu33twq",
  type: "brand",
  name: "Sauce Everywhere",
  avatarUrl:
    "https://cdn.faire.com/fastly/15bb6374a135b3f2c99b7273e1c22a87831d1a0d817702e172f0441e1ab534cc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a179b7e6211e58f2056b9a653d976276fff5aa320c1b81c8a6a429ba5b4b5a2e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/15bb6374a135b3f2c99b7273e1c22a87831d1a0d817702e172f0441e1ab534cc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a179b7e6211e58f2056b9a653d976276fff5aa320c1b81c8a6a429ba5b4b5a2e.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 132,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    'We make small batch chile sauces that give food more flavor. \n\nWe started Sauce Everywhere to give people an easy way to enhance the taste and texture of their meals. All you have to do is add that sauce. \n\nOur sauces are inspired by the Southwest and Mexico, where sauce goes on everything. We think of each one as an "everyday sauce." They\'re meant for any food at any time. \n\nWe only use quality ingredients, often from farmers we know. Spice levels vary from mild to medium. \n\nFounded by Chef Chris Chapman. Roots in the Bay, based in Colorado. More flavor, less labor.',
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:35.062Z",
    importedBy: "entity-db-cli",
  },
};
